export const getUserAgent = () => navigator.userAgent
